import LoadingService from './loading.service';
import AuthService from './auth.service';
import { s3Instance } from './s3.service';
import DemoService from './demo.service';
import ExtendMixins from './ExtendMixins.service';
import GenerateXLS from './GenerateXLS.service';
import GeneratePDF from './GeneratePDF.service';

export {
  LoadingService,
  AuthService,
  s3Instance,
  DemoService,
  ExtendMixins,
  GenerateXLS,
  GeneratePDF,
};
